import React, { useState, useRef, useEffect } from 'react';
import {
    FormControl, FormControlLabel, Typography, TextField, RadioGroup, Radio, Checkbox,
    Button, Box, FormHelperText, Autocomplete
} from '@mui/material';
// import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
// import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Formik, useFormik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { editOrder, fetchOrderById, fetchSuppliersByCompanyId, resetOrderState } from '../../../redux/orderSlice';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getDate } from '../../../helpers/helperFunction';

dayjs.extend(localizedFormat);
const formattedDate = dayjs().format('LL');


// Create a new object with the shape of our input initial state variable.const 

export const EDIT_ORDER_VALIDATION = yup.object().shape({
    orderNumber: yup.string().required('Purchase Order cannot be empty.'),
    supplierCompanyKeyId: yup.string().required('Supplier is required.'),
    orderDate: yup.date().required('Order date is required.'),
    orderExpectedDate: yup.date().required('Order due date is required.'),
    orderDescription: yup.string().max(300, 'Address cannot exceed 300 characters.'),

})
const EditOrder = ({ onSubmit, handleStepChange, actionType }) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { orderId } = useParams();
    const orderDetails = useSelector((state) => state.order.orderDetails?.data || {});
    const { ...rest } = useSelector((state) => state.order.orderDetails?.data || {});


    console.log(">>:: Edit ORDER ::>>>", orderDetails, actionType)
    const isLoading = useSelector(state => Object.values(state.order.loading).some(status => status));

    useEffect(() => {
        // dispatch(resetOrderState())
        dispatch(fetchSuppliersByCompanyId());
    }, [dispatch]);
    useEffect(() => {
        dispatch(fetchOrderById(orderId));

    }, [dispatch, orderId]);

    const handleEditMyOrderSubmit = (formattedValues) => {
        const companyData = formattedValues
        // dispatch(updateCompanyAPI(companyData))

        dispatch(editOrder({
            orderId: orderId,
            orderData: companyData
        }))
            .then((response) => {
                const orderResponse = response.payload
                console.log("response", orderResponse);
                if (orderResponse.data === 1) {
                    navigate('/outbox-order');
                }
            })
            .catch((error) => {
                console.error("Fetching user details error:", error);
            });
    }
    return (
        <>
            <div>
                <h1 className="fprimary">Edit Order </h1>
                <h5 className="">Edit carefully Order details</h5>
            </div>
            <div className="card mt-3 bg-stage">
                <div className="card-body">
                    <div className='row'>
                        <div className="col-md-2">
                            <h1 className="fprimary">Order Details&nbsp;&nbsp;</h1>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-4">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 border-end pe-2">
                                    <p className="font-13 mb-0">Supplier</p>
                                    <div className="bg-slash font-14">{orderDetails.supplierCompany?.companyName}</div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 pe-2">
                                    <p className="font-13 mb-0">Link Buyer Purchase Order</p>
                                    <div className="bg-slash font-14">{orderDetails.linkedOrderNumber}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 pe-2">
                                    <p className="font-13 mb-0">Order Date</p>
                                    <div className="bg-slash font-14">{getDate(orderDetails.orderDate)}</div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-2">
                            <div className="d-flex justify-content-between indect">
                                <div className="left-box w-100 pe-2">
                                    <p className="font-13 mb-0">Due Date</p>
                                    <div className="bg-slash font-14">{getDate(orderDetails.orderExpectedDate)}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row m-3">

                    <Formik
                        // orderDetails={editValue || defaultValues}
                        initialValues={{
                            orderNumber: orderDetails?.orderNumber || '',
                            supplierCompanyKeyId: orderDetails?.supplierCompany?.companyKeyId || '',
                            orderDate: getDate(orderDetails?.orderDate),
                            orderExpectedDate: getDate(orderDetails?.orderExpectedDate),
                            orderDescription: orderDetails?.orderDescription || '',
                            ...rest
                        }}
                        enableReinitialize={true}
                        // validationSchema={EDIT_ORDER_VALIDATION}
                        onSubmit={(values, { setSubmitting }) => {
                            const formattedValues = {
                                ...values,
                                orderDate: getDate(values.orderDate),
                                orderExpectedDate: getDate(values.orderExpectedDate),

                            };
                            console.log('Formatted Submit:', formattedValues);
                            handleEditMyOrderSubmit(formattedValues);
                            onSubmit(formattedValues);
                            setSubmitting(false);
                        }}

                    >
                        {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched }) => (
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className="col-md-6 cs-form mb-3">
                                        <TextField
                                            label={t('createOrder.purchaseOrder')}
                                            className='md-input'
                                            name='orderNumber'
                                            value={values.orderNumber}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.orderNumber}
                                            helperText={errors.orderNumber}
                                        />
                                    </div>

                                    <div className="col-md-12 cs-form mb-3">
                                        <TextField
                                            label={t('createOrder.description')}
                                            className='md-input'
                                            name='orderDescription'
                                            multiline
                                            rows={4}
                                            value={values.orderDescription}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            error={errors.orderDescription}
                                            // helperText={.errors.orderDescription}
                                            inputProps={{
                                                maxLength: 300,
                                            }}
                                            helperText={`${values.orderDescription.length}/300`}
                                        />
                                    </div>

                                    <div className="d-flex justify-content-between">
                                        <button type="button" className="btn btn-light grey-btn lg-btn" onClick={() => navigate(-1)}>{t('createOrder.back')}</button>

                                        <button
                                            className="btn btn-primary greeen-btn lg-btn"
                                            type='submit'
                                            variant="contained"
                                            onClick={handleSubmit} // Use onClick to trigger form submission
                                        // disabled={ isValid || isSubmitting }
                                        >
                                            {/* Create Order */}
                                            {isLoading ? 'Submitting...' : t('createOrder.updateOrderbtn')}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        )}
                    </Formik >
                </div>
            </div>

        </>
    )
}
export default EditOrder